// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/RightPane/css/RightPane.css
// module id = 1228
// module chunks = 5